import cx from 'classnames';

import {Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {HeaderProps} from './Header.types';

function getHeader(percentage = 0) {
  if (percentage === 0) {
    return 'It’s not too late!';
  }

  if (percentage === 100) {
    return 'Way to go!';
  }

  if (percentage >= 60) {
    return 'Keep pushing!';
  }

  return 'Slow but steady!';
}

function getLede(percentage = 0) {
  if (percentage === 0) {
    return 'Based on your check-in, you haven’t hit any of your weekly goals, but that’s ok. We all hit a wall sometimes. For next week, aim to focus on only one recommendation.';
  }

  if (percentage === 100) {
    return 'Based on your check-in, you’re consistently hitting your goals, keep it up! If you’re up for a challenge, try changing your Action Plan’s adjustment level or building on your existing recommendations.';
  }

  if (percentage >= 60) {
    return 'Based on your check-in, you’re on track to hit your goals, don’t stop! For next week, aim to focus on adding one more recommendation to your keep doing list.';
  }

  return 'Based on your check-in, you sometimes hit your goals but you’re committed and that’s what counts. For next week, aim to focus on adding one more recommendation to your keep doing list.';
}

/**
 * This component renders the header of the Check In page's result screen. The
 * content is conditionally rendered based on the percentage of questions the
 * user answered affirmatively for the specific checkIn.
 */
export const Header = ({className, percentage = 0, ...otherProps}: HeaderProps) => (
  <div className={cx(sprinkles({flex: 'flex', dir: 'col', gap: 8}), className)} {...otherProps}>
    <Text as="h2" color="burgundy" variant="heading2">
      {getHeader(percentage)}
    </Text>

    <Text as="p" color="mineShaft">
      {getLede(percentage)}
    </Text>
  </div>
);
